import React from 'react'
import styled from 'styled-components'
import Img from 'gatsby-image'
import Colors from 'styles/Colors'

import { ReactComponent as BGElementSVG } from 'svg/aboutPartnersBGElement.svg'
import { ReactComponent as HyundaiSVG } from 'svg/hyundai.svg'
import { ReactComponent as ToyotaVenturesSVG } from 'svg/toyotaVentures.svg'
import { ReactComponent as ScrumVenturesSVG } from 'svg/scrumVentures.svg'
import { ReactComponent as OmronSVG } from 'svg/omronLogo.svg'
import { ReactComponent as MitsubishiSVG } from 'svg/mitsubishi.svg'

import { FluidImage } from 'Types'

import media from 'styles/media'

type Props = {
  data: {
    dukeAngelNetwork: FluidImage
    sparkx: FluidImage
    sAIC: FluidImage
    hahn: FluidImage
    heroic: FluidImage
    soundproof: FluidImage
  }
}
const Partners: React.FC<Props> = ({ data }) => {
  return (
    <Wrapper>
      <Title>Proudly backed by</Title>
      <PartnersWrapper>
        <a
          href="https://www.sparxgroup.com/"
          aria-label="sparxgroup.com"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Sparkx>
            <Img
              fluid={data.sparkx.childImageSharp.fluid}
              alt={'Sparkx Logo'}
            />
          </Sparkx>
        </a>
        <a
          href="https://soundproofvc.com/"
          aria-label="soundproofvc.com"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Soundproof>
            <Img
              fluid={data.soundproof.childImageSharp.fluid}
              alt={'Soundproof Ventures logo'}
            />
          </Soundproof>
        </a>
        <LogoWrapper>
          {' '}
          <a
            href="https://www.omron.com/ventures/"
            aria-label="omron.com"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Omron />{' '}
          </a>
        </LogoWrapper>
        <a
          href="https://www.omron.com/ventures/"
          aria-label="omron.com"
          target="_blank"
          rel="noreferrer noopener"
        >
          <LogoWrapper>
            <OmronMobile />
          </LogoWrapper>
        </a>
        <LogoWrapper>
          <a
            href="https://www.mitsubishielectric.com/en/index.html"
            aria-label="mitsubishielectric.com"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Mitsubishi />
          </a>
        </LogoWrapper>
        <a
          href="https://www.hahnautomation.com/en/"
          aria-label="https://www.hahnautomation.com/en/"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Hahn>
            <Img
              fluid={data.hahn.childImageSharp.fluid}
              alt={'Hahn Automation Logo'}
            />
          </Hahn>
        </a>
        <a
          href="https://saicvc.com/"
          aria-label="saicvc.com"
          target="_blank"
          rel="noreferrer noopener"
        >
          <SAIC>
            <Img
              fluid={data.sAIC.childImageSharp.fluid}
              alt={'Duke Angel Network Logo'}
            />
          </SAIC>
        </a>
        <LogoWrapper>
          {' '}
          <a
            href="https://www.cradleinc.com/"
            aria-label="hyundai cradlelink homepage"
            target="_blank"
            rel="noreferrer noopener"
          >
            <Hyundai />{' '}
          </a>
        </LogoWrapper>
        <a
          href="https://www.heroicvc.com/"
          aria-label="Heroic Ventures"
          target="_blank"
          rel="noreferrer noopener"
        >
          <Heroic>
            <Img
              fluid={data.heroic.childImageSharp.fluid}
              alt={'Heroic Ventures Logo'}
            />
          </Heroic>
        </a>
        <a
          href="http://toyota-ai.ventures/"
          aria-label="toyota ventures homepage"
          target="_blank"
          rel="noreferrer noopener"
        >
          <ToyotaVentures />
        </a>
        <a
          href="https://scrum.vc/"
          aria-label="scrum homepage"
          target="_blank"
          rel="noreferrer noopener"
        >
          <ScrumVentures />
        </a>
        <a
          href="https://dukeangelnetwork.duke.edu/"
          aria-label="duke Angel Network homepage"
          target="_blank"
          rel="noreferrer noopener"
        >
          <DukeAngelMobile>
            <Img
              fluid={data.dukeAngelNetwork.childImageSharp.fluid}
              alt={'Duke Angel Network Logo'}
            />
          </DukeAngelMobile>
        </a>

        <a
          href="https://dukeangelnetwork.duke.edu/"
          aria-label="duke Angel Network homepage"
          target="_blank"
          rel="noreferrer noopener"
        >
          <DukeAngel>
            <Img
              fluid={data.dukeAngelNetwork.childImageSharp.fluid}
              alt={'Duke Angel Network Logo'}
            />
          </DukeAngel>
        </a>
      </PartnersWrapper>
      <BgElement />
    </Wrapper>
  )
}

const Wrapper = styled.section`
  height: 916px;
  padding: 248px 0 91px;
  position: relative;
  overflow: hidden;

  background: ${Colors.softBlack};

  ${media.tabletLandscape} {
    height: 86.8vw;
    padding: 6.3vw 9.4vw 28.4vw;
  }

  ${media.tablet} {
    height: auto;
    padding: 6.3vw 6.3vw 28.4vw;
  }
  ${media.mobile} {
    height: min-content;
    padding: 0 3.2vw;
  }
`

const Title = styled.h1`
  font-weight: 500;
  font-size: 54px;
  line-height: 104%;
  margin-left: 36.6vw;
  color: ${Colors.whiteSmoke};
  ${media.fullWidth} {
    font-size: 54px;
  }

  ${media.tabletLandscape} {
    width: 353px;
    margin-left: 0;
  }
  ${media.tablet} {
    width: 310.3px;
  }
  ${media.mobile} {
    font-size: 9.6vw;
    margin-bottom: 12.8vw;
    width: 62.9vw;
  }
`
const BgElement = styled(BGElementSVG)`
  position: absolute;
  width: 353px;
  height: 381px;
  right: 174px;
  top: 539px;
  z-index: 1;
  @media screen and (max-width: 1566px) {
    display: none;
  }

  ${media.tabletLandscape} {
    width: 36.8vw;
    height: 40vw;
    right: 8vw;
    top: 46.1vw;
    left: auto;
  }
  ${media.tablet} {
    top: 60vw;
    right: 8vw;
  }
  ${media.mobile} {
    width: 52.5vw;
    height: 57.1vw;
    left: 45vw;
    top: 110vw;
    right: auto;
  }
`
const Hyundai = styled(HyundaiSVG)`
  width: 258px;
  height: 33px;
  margin-right: 150px;
  @media only screen and (max-width: 1279px) {
    margin-right: 100px;
  }
  ${media.tabletLandscape} {
    width: 22vw;
    height: 2.9vw;
    margin-right: 80px;
  }
  ${media.tablet} {
    margin-bottom: 0;
    width: 22vw;
  }
  ${media.mobile} {
    width: 45.1vw;
    height: 5vw;
    margin-left: -3vw;
    margin-right: 10vw;
  }
`
const ToyotaVentures = styled(ToyotaVenturesSVG)`
  width: 197px;
  height: 53px;
  margin-right: 150px;
  margin-bottom: 75px;
  opacity: 0.48;
  ${media.tabletLandscape} {
    width: 16.9vw;
    height: 4.6vw;
    margin-right: 16.7vw;
  }
  ${media.tablet} {
    margin-right: 0;
    width: 16.9vw;
    height: 4.6vw;
  }
  ${media.mobile} {
    width: 24.7vw;
    height: 9.3vw;
    margin-right: 9vw;
    margin-bottom: 12.3vw;
    line-height: 9.3vw;
  }
`
const ScrumVentures = styled(ScrumVenturesSVG)`
  width: 297px;
  height: 53px;
  margin-right: 150px;
  margin-bottom: 75px;
  opacity: 0.48;

  ${media.tabletLandscape} {
    width: 25.5vw;
    height: 2.9vw;
    margin-right: 80px;
  }

  ${media.mobile} {
    width: 42.3vw;
    height: 5.9vw;
    margin-right: 0vw;
    margin-bottom: 12.3vw;
    line-height: 9.3vw;
  }
`
const Omron = styled(OmronSVG)`
  width: 129px;
  height: 27px;
  margin-right: 150px;
  margin-top: 35px;

  @media only screen and (max-width: 1405px) {
    margin-right: 150px;
  }
  ${media.tabletLandscape} {
    width: 10.9vw;
    height: 2.2vw;
    margin-right: 10vw;
  }

  ${media.tablet} {
    width: 10.9vw;
    height: 2.2vw;
    margin-right: 13.3vw;
  }
  ${media.mobile} {
    display: none;
  }
`
const OmronMobile = styled(OmronSVG)`
  display: none;
  ${media.mobile} {
    opacity: 0.48;
    display: inline-block;
    width: 22.4vw;
    height: 4.5vw;
    margin-right: 10vw;
  }
`

const Mitsubishi = styled(MitsubishiSVG)`
  width: 178px;
  height: 53px;
  margin-right: 150px;
  margin-top: 7px;

  @media only screen and (max-width: 1279px) {
    margin-right: 150px;
  }
  ${media.tabletLandscape} {
    margin-right: 100px;
    margin-top: -60px;
    width: 15.2vw;
    height: 4.6vw;
  }
  ${media.mobile} {
    margin-top: 0;
    margin-right: 7vw;
    width: 31.2vw;
    height: 9.3vw;
    margin-bottom: 12.3vw;
  }
`

const PartnersWrapper = styled.div`
  display: flex;
  position: relative;
  flex-wrap: wrap;
  align-items: flex-end;

  width: 1225px;
  margin-left: 96px;
  margin-top: 96px;
  @media only screen and (max-width: 1405px) {
    width: 72.9vw;
    margin-left: 96px;
  }
  @media only screen and (max-width: 1279px) {
    width: 1000px;
  }
  ${media.tabletLandscape} {
    margin-left: 0;
    margin-top: 7.2vw;
    width: 100%;
  }
  ${media.tablet} {
    margin-left: 0;
    margin-top: 7.2vw;
    height: min-content;

    width: 100%;
  }
`

const DukeAngel = styled.div`
  width: 283px;
  height: 53px;
  margin-right: 0;
  margin-bottom: 75px;
  opacity: 0.48;
  @media only screen and (max-width: 1279px) {
    margin-right: 0;
  }
  ${media.tabletLandscape} {
    margin-right: 10vw;
    width: 24.3vw;
    height: 4.6vw;
  }

  ${media.tablet} {
    margin-right: 13.3vw;
    margin-bottom: 10.4vw;
  }
  ${media.mobile} {
    display: none;
  }
`

const DukeAngelMobile = styled.div`
  display: none;
  ${media.mobile} {
    opacity: 0.48;
    display: inline-block;
    width: 49.9vw;
    height: 9.3vw;
    margin-right: 12.5vw;
    margin-bottom: 12.3vw;
  }
`

const Sparkx = styled.div`
  width: 75px;
  height: 53px;
  margin-right: 150px;
  margin-bottom: 75px;
  opacity: 0.48;
  ${media.tabletLandscape} {
    margin-right: 10vw;
  }
  ${media.tablet} {
    margin-bottom: 12.3vw;
    width: 9.3vw;
  }
  ${media.mobile} {
    margin-right: 12vw;
    margin-bottom: 12.3vw;
    width: 13.3vw;
    height: 9.3vw;
  }
`

const SAIC = styled.div`
  width: 72px;
  height: 72px;
  margin-bottom: 75px;
  margin-right: 132px;
  opacity: 0.48;
  ${media.tabletLandscape} {
    width: 8vw;
    height: 8vw;
    margin-top: -50px;
  }
  ${media.tablet} {
    margin-bottom: 12.3vw;
    width: 7vw;
    margin-top: -3vw;
  }
  ${media.mobile} {
    margin-top: -1.3vw;
    margin-right: 0;
    width: 10vw;
    height: 10vw;
  }
`
const Hahn = styled.div`
  width: 158px;
  height: 76px;
  margin-bottom: 15px;
  margin-right: 132px;
  opacity: 0.48;
  @media only screen and (max-width: 1405px) {
    margin-right: 150px;
  }
  ${media.tabletLandscape} {
    width: 14vw;
    margin-bottom: 70px;
  }
  ${media.tablet} {
    width: 14vw;
    margin-bottom: 10vw;
    margin-right: 13vw;
  }
  ${media.mobile} {
    margin-bottom: 0;
    width: 30vw;
    margin-right: 6vw;
  }
`

const LogoWrapper = styled.div`
  height: 53px;
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0.48;
  margin-bottom: 75px;
  ${media.tabletLandscape} {
    height: 4.6vw;
  }
  ${media.tablet} {
    height: 4.6vw;
  }
  ${media.mobile} {
    height: 9.3vw;
    margin-bottom: 12.3vw;
  }
`
const Soundproof = styled.div`
  width: 162px;
  margin-right: 156px;
  margin-top: -80px;
  opacity: 0.48;
  ${media.mobile} {
    width: 23.2vw;
    margin-top: -12vw;
    margin-right: 10vw;
  }
`
const Heroic = styled.div`
  width: 81px;
  opacity: 0.48;
  margin-top: -80px;
  @media only screen and (max-width: 1406px) {
    margin-right: 80px;
  }
  ${media.mobile} {
    width: 15vw;
    margin-top: -10vw;
    margin-right: 0;
  }
`

export default Partners
